import React from "react";
import { Link } from "react-scroll";
import { ImCircleUp, ImGithub, ImTwitter, ImLinkedin } from "react-icons/im";

function Contact() {
  return (
    <div className="pt-8 pb-8 bg-white">
      <div className="container mx-auto" id="contact">
        <div className="flex flex-col">
          <h4 className="text-2xl text-black font-semibold">
            Get in touch with me
          </h4>
          <div className="flex justify-center p-8">
            <form name="contact" method="POST">
              <input type="hidden" name="form-name" value="contact" />
              <div className="mb-6">
                <label
                  for="name"
                  className="block mb-2 text-sm font-medium text-black"
                >
                  Name*
                </label>
                <input
                  type="text"
                  htmlFor="name"
                  id="name"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block lg:w-96 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="mb-6">
                <label
                  htmlFor="email"
                  className="block mb-2 text-sm font-medium text-black"
                >
                  Email*
                </label>
                <input
                  type="email"
                  name="email"
                  id="email"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block lg:w-96 w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Your Email Address"
                  required
                />
              </div>
              <div className="mb-6">
                <label
                  htmlFor="message"
                  className="block mb-2 text-sm font-medium  text-black"
                >
                  Message*
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows="8"
                  className="block p-2.5 lg:w-96 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Your message..."
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              >
                Submit
              </button>
            </form>
          </div>
          <span className="flex justify-center pt-6">
            <ImGithub className="basis-28 h-10 w-10 text-black cursor-pointer" />
            <ImTwitter className="basis-28 h-10 w-10 text-black cursor-pointer" />
            <ImLinkedin className="basis-28 h-10 w-10 text-black cursor-pointer" />
          </span>
          <Link
            to="home"
            spy={true}
            smooth={true}
            offset={-70}
            duration={500}
            className="flex justify-center pt-8"
          >
            <ImCircleUp className="h-10 w-10 align-middle text-purple-800 hover:text-amber-700 cursor-pointer animate-bounce" />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Contact;
